// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 977 ? "orderCreate" : chunkId) + "." + {"977":"974bd137","994":"1ecf3cab"}[chunkId] + ".css";
};